(function($){"use strict";var $window=$(window);$window.load(function(){$(".preloader").fadeOut(200)})})(jQuery)
document.addEventListener('DOMContentLoaded', () => {
  // Debounce window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        document.querySelectorAll('[data-bg]').forEach(image => {
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
            image.style.backgroundImage = `url(${mobileBg})`;
          }
        });
      });
    }, 100);
  });

  // Lazyloaded background images
  document.addEventListener('lazyloaded', e => {
    requestAnimationFrame(() => {
      let bg = e.target.getAttribute('data-bg');
      const mobileBg = e.target.getAttribute('data-mobile-bg');
      if (bg && window.PXUTheme.media_queries.medium.matches && mobileBg) bg = mobileBg;
      e.target.style.backgroundImage = `url(${bg})`;
    });
  });
});


  